var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "#fff",
    stroke: "#CCCCCC",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5005 14.0625C29.5005 15.3266 28.4429 16.375 27.1086 16.375C25.7745 16.375 24.7168 15.3266 24.7168 14.0625V2.8125C24.7168 1.54836 25.7745 0.5 27.1086 0.5C28.4429 0.5 29.5005 1.54834 29.5005 2.8125V14.0625Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8423 1.24144L19.8425 1.24155L19.9385 1.28816C21.0775 1.84212 21.7884 2.96907 21.7884 4.19263V14.375C21.7884 15.886 21.2846 17.358 20.3502 18.5697L17.6511 22.0696L18.0471 22.3749L17.6511 22.0696C16.5833 23.4544 16.0048 25.1406 16.0048 26.8749V28.125C16.0048 28.8714 15.3787 29.5 14.5769 29.5C12.7104 29.5 11.2212 28.032 11.2212 26.25V18.75V18.25H10.7212H3.85709C1.72315 18.25 0.155998 16.3587 0.565935 14.3653L2.87941 3.11528C3.19019 1.60401 4.56048 0.5 6.17056 0.5H16.6123C17.734 0.5 18.8401 0.75406 19.8423 1.24144Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/Dislike.097330d22f32199f58767daf75f131b6.svg";
export { ForwardRef as ReactComponent };